import type { BackendRouteDefinition } from '../types';
import type { GetPaymentPageUnauthenticated } from '@cloudFunctions/types/clientToFirmPayments/getPaymentPageUnauthenticated';

export const getPaymentPageUnauthenticatedRoute = {
  transport: 'api',
  method: 'GET',
  path: '/public/payment-pages/:paymentPageId',
  params: ({ paymentPageId }: GetPaymentPageUnauthenticated.Props) => ({
    paymentPageId,
  }),
} as const satisfies BackendRouteDefinition;
